const region = process.env.COCOS_REGION || 'eu'
const insertRegion = (value: string): string => value.replace('{{REGION}}', region)

const getApiUrl = () => {
    const defaultApiUrl = insertRegion(process.env.API_URL ?? '')
    const currentOrigin = window.location.origin

    const DCC_APP_ENV_PATTERN = /(dcc-app|fong-app).*audi\.io/
    const LOCALHOST_PATTERN = /localhost/

    if (DCC_APP_ENV_PATTERN.test(currentOrigin) || LOCALHOST_PATTERN.test(currentOrigin)) {
        return defaultApiUrl
    }

    return `${currentOrigin}/dccbff`
}

export default Object.freeze({
    STAGE: process.env.SPACE,
    APP_VERSION: process.env.APP_VERSION ?? '',
    API_URL: getApiUrl(),
    TRANSLATION_SERVICE_URL: insertRegion(process.env.TRANSLATION_SERVICE_URL ?? ''),
    TRACKING_URL: process.env.TRACKING_URL ?? '',
    TRACKING_ENABLED_BRANDS_LIST: process.env.TRACKING_ENABLED_BRANDS_LIST ?? 'audi',
    PDF_SERVICE_URL: process.env.PDF_SERVICE_URL ?? '',
    MIWI_MOD_FEATURE_APP_URL: insertRegion(process.env.MIWI_MOD_FEATURE_APP_URL ?? ''),
    MIWI_FEATURE_APP_URL: insertRegion(process.env.MIWI_FEATURE_APP_URL ?? ''),
    MIWI_FEATURE_LIBRARY_URL: insertRegion(process.env.MIWI_FEATURE_LIBRARY_URL ?? ''),
    MIWI_FEATURE_BACKEND_SWITCHER: process.env.MIWI_FEATURE_BACKEND_SWITCHER ?? '',
    REACT_VERSION: process.env.REACT_VERSION,
    FEATURE_HUB_REACT_VERSION: process.env.FEATURE_HUB_REACT_VERSION,
    AUDI_EXCLUSIVE_WEB_COMPONENT_VERSION: process.env.AUDI_EXCLUSIVE_WEB_COMPONENT_VERSION ?? '',
    E3DEX_APP_URL: process.env.E3DEX_APP_URL ?? '',
    E3DEX_GRP_CLIENT_ID: process.env.E3DEX_GRP_CLIENT_ID ?? '',
    E3DEX_GRP_AUTH_DOMAIN_URL: process.env.E3DEX_GRP_AUTH_DOMAIN_URL ?? '',
    E3DEX_PARTNER_TOKEN: process.env.E3DEX_PARTNER_TOKEN ?? '',
    E3DEX_EVA_PARTNER_TOKEN: process.env.E3DEX_EVA_PARTNER_TOKEN ?? '',
    AVP_STAGE: process.env.AVP_STAGE ?? '',
})
